module.exports = __webpack_public_path__ + "static/media/tick.1316d0d9.svg";